<template>
	<div class="button">
		<span class="linkWrapper">
			<a :href="link" target="_blank">{{text}}</a>
		</span>
	</div>
</template>
​
<script>
	export default {
		props: ['text','link']
	}
</script>

<style scoped>
	.linkWrapper{
		padding: 8px;
		border-radius: 4px;
		background: linear-gradient(-90deg, #224467, #234);
		transition: all 0.3s;
	}
	.linkWrapper:hover{
		box-shadow: 0 0 10px rgba(0,0,0,0.3);
	}
	a{
		color: inherit;
		text-decoration: none;
		font-weight: bold;
	}
</style>


// WEBPACK FOOTER //
// src/components/Button.vue